window.cloudJumpAssets = {
  colors: [
    'baby-pink',
    'bordeaux',
    'cloud-white',
    'forest-green',
    'navy-blue',
    'choco-brown',
    'gym-grey',
    'pitch-black'
  ],
  silhouettes: ['crewneck', 'full-zip', 'hoodie'],
  powerupTypes: ['jetpack', 'hat'],
  characters: {},
  characterPowerups: {},
  platforms: {
    normal: [],
    moving: [],
    fakeSprite: null,
    start: null
  },
  powerups: {
    small: null,
    medium: null,
    large: null
  },
  animations: {
    jetpackFlame: null,
    electricDeath: null
  },
  hazards: {
    airplane: null,
    hotAirBalloon: null,
    explosion: null
  },
  imagesLoaded: false,
  loadedCount: 0,
  totalImages: 0
};

window.cloudJumpAssetUrl = function(name) {
  const ref = window.cloudJumpAssetBase || { base: '', query: '' };
  return ref.base + name + ref.query;
};

window.setCloudJumpSilhouette = function(silhouette) {
  const assets = window.cloudJumpAssets;
  if (!assets.silhouettes.includes(silhouette)) {
    console.warn('Unknown silhouette:', silhouette);
    return Promise.resolve();
  }

  window.cloudJumpSilhouette = silhouette;
  assets.characters = {};
  assets.characterPowerups = {};

  assets.colors.forEach(color => {
    assets.characters[color] = window.cloudJumpAssetUrl(`${color}_${silhouette}.png`);
    assets.powerupTypes.forEach(powerup => {
      assets.characterPowerups[`${color}_${powerup}`] =
        window.cloudJumpAssetUrl(`${color}_${powerup}_${silhouette}.png`);
    });
  });

  return window.preloadCloudJumpAssets();
};

window.preloadCloudJumpAssets = function() {
  return new Promise((resolve, reject) => {
    const assets = window.cloudJumpAssets;
    const images = {};
    const imagesToLoad = [];

    Object.keys(assets.characters).forEach(char => {
      if (assets.characters[char]) {
        imagesToLoad.push({ key: `character_${char}`, url: assets.characters[char] });
      }
    });

    Object.keys(assets.characterPowerups).forEach(key => {
      if (assets.characterPowerups[key]) {
        imagesToLoad.push({ key: `powerup_${key}`, url: assets.characterPowerups[key] });
      }
    });

    assets.platforms.normal.forEach((url, idx) => {
      if (url) imagesToLoad.push({ key: `platform_normal_${idx}`, url });
    });

    assets.platforms.moving.forEach((url, idx) => {
      if (url) imagesToLoad.push({ key: `platform_moving_${idx}`, url });
    });

    if (assets.platforms.start) {
      imagesToLoad.push({ key: 'platform_start', url: assets.platforms.start });
    }

    if (assets.platforms.fakeSprite) {
      imagesToLoad.push({ key: 'platform_fake_sprite', url: assets.platforms.fakeSprite });
    }

    Object.keys(assets.powerups).forEach(type => {
      if (assets.powerups[type]) {
        imagesToLoad.push({ key: `powerup_${type}`, url: assets.powerups[type] });
      }
    });

    if (assets.animations) {
      if (assets.animations.jetpackFlame) {
        imagesToLoad.push({ key: 'animation_jetpack_flame', url: assets.animations.jetpackFlame });
      }
      if (assets.animations.electricDeath) {
        imagesToLoad.push({ key: 'animation_electric_death', url: assets.animations.electricDeath });
      }
    }
    if (assets.hazards) {
      if (assets.hazards.airplane) {
        imagesToLoad.push({ key: 'hazard_airplane', url: assets.hazards.airplane });
      }
      if (assets.hazards.hotAirBalloon) {
        imagesToLoad.push({ key: 'hazard_balloon', url: assets.hazards.hotAirBalloon });
      }
      if (assets.hazards.explosion) {
        imagesToLoad.push({ key: 'hazard_explosion', url: assets.hazards.explosion });
      }
    }

    assets.totalImages = imagesToLoad.length;
    assets.loadedCount = 0;
    assets.imagesLoaded = false;

    if (imagesToLoad.length === 0) {
      assets.imagesLoaded = true;
      resolve(images);
      return;
    }

    let loadedCount = 0;

    imagesToLoad.forEach(({ key, url }) => {
      const img = new Image();
      img.onload = () => {
        images[key] = img;
        loadedCount++;
        assets.loadedCount = loadedCount;
        if (loadedCount === imagesToLoad.length) {
          assets.imagesLoaded = true;
          window.cloudJumpLoadedImages = images;
          resolve(images);
        }
      };
      img.onerror = () => {
        console.warn(`Failed to load image: ${url}`);
        loadedCount++;
        assets.loadedCount = loadedCount;
        if (loadedCount === imagesToLoad.length) {
          assets.imagesLoaded = true;
          window.cloudJumpLoadedImages = images;
          resolve(images);
        }
      };
      img.src = url;
    });
  });
};

window.getRandomCloudVariant = function() {
  return Math.floor(Math.random() * 5) + 1;
};